import alpha from "color-alpha";
const shadowedStyles = ({
  theme,
  ownerState
}) => {
  var _a;
  if (ownerState.variant !== "shadowed")
    return;
  const white = theme.palette.common.white ?? "#fff";
  if (ownerState.color === "grey") {
    return {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.grey[900],
      boxShadow: "0px -0.5px 1px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);",
      "&:hover": {
        backgroundColor: "#F0F0F0",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: "#E8E8E8",
        boxShadow: `0px 0px 0px 1px ${theme.palette.grey[900]}, 0px 0px 0px 3px ${theme.palette.grey[200]}, 0px -0.5px 1px 3px rgba(0, 0, 0, 0.1), 0px 0.5px 1px 3px rgba(0, 0, 0, 0.35);`
      },
      "&:active": {
        boxShadow: "0px -0.5px 1px rgba(0, 0, 0, 0.1), 0px 0.5px 1px rgba(0, 0, 0, 0.35);"
      },
      "&:disabled": {
        backgroundColor: alpha(white, 0.12),
        color: alpha(theme.palette.grey[900], 0.38),
        boxShadow: "none"
      }
    };
  }
  let paletteKey;
  if (ownerState.color === "aqua")
    paletteKey = "primary";
  else if (ownerState.color === "blue")
    paletteKey = "highlight2";
  else if (ownerState.color === "purple")
    paletteKey = "highlight3";
  else if (ownerState.color === "orange")
    paletteKey = "secondary";
  else
    paletteKey = ownerState.color;
  const colorKey = 900;
  const colorValue = (_a = theme.palette[paletteKey]) == null ? void 0 : _a[colorKey];
  if (!colorValue) {
    console.warn(`Color value for key "${paletteKey}" is not defined in theme palette.`);
    return;
  }
  return {
    backgroundColor: "#F5F5F5",
    color: colorValue,
    boxShadow: "0px 0.5px 1px rgba(0, 0, 0, 0.25), 0px -0.5px 0px rgba(0, 0, 0, 0.05);",
    "&:hover": {
      backgroundColor: "#E7E7E7",
      boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
    },
    "&:focus-visible": {
      backgroundColor: "#E0E0E0",
      boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.grey[200]}, 0px 0.5px 1px 3px rgba(0, 0, 0, 0.25), 0px -0.5px 0px 3px rgba(0, 0, 0, 0.05);`
    },
    "&:active": {
      boxShadow: "0px 0.5px 1px rgba(0, 0, 0, 0.25), 0px -0.5px 0px rgba(0, 0, 0, 0.05);"
    },
    "&:disabled": {
      backgroundColor: "#F5F5F51F",
      color: alpha(theme.palette.grey[900], 0.38),
      boxShadow: "none"
    }
  };
};
export {
  shadowedStyles
};
